import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import { useState, useRef, useEffect } from 'react';
import { languages } from 'i18n/options';
import { extractTextFromPdf } from './extractTextFromPdf';
import api from 'utils/api';
import config from 'utils/config';
import { FILE_FORMATS } from 'utils/asset/constants';
import getAssetType from 'utils/asset/getAssetType';
function getCorrectLanguageCode(detectedLanguage) {
  if (!detectedLanguage) return;
  var languageCode = languages.find(function (lang) {
    return lang.alias.some(function (alias) {
      return alias === detectedLanguage;
    });
  });
  return languageCode === null || languageCode === void 0 ? void 0 : languageCode.value;
}
export function useAiSuggestions() {
  var _useState = useState({
      description: {
        status: 'none'
      },
      locale: {
        status: 'none'
      }
    }),
    _useState2 = _slicedToArray(_useState, 2),
    aiSuggestions = _useState2[0],
    setAiSuggestions = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    fileForAsyncAnalysis = _useState4[0],
    setFileForAsyncAnalysis = _useState4[1];
  var isAnalysisInProgressRef = useRef(false);
  useEffect(function () {
    var _getAssetType;
    if (config.assetEditorAutoSuggestions && fileForAsyncAnalysis && isAnalysisInProgressRef.current === false && ((_getAssetType = getAssetType(fileForAsyncAnalysis)) === null || _getAssetType === void 0 ? void 0 : _getAssetType.fileFormat) === FILE_FORMATS.PDF) {
      var extractSummary = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var text, _yield$api, contentError, chatGptDescription, detectedLanguageCode, detectedLocale;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                isAnalysisInProgressRef.current = true;
                setAiSuggestions(function (prev) {
                  return _objectSpread(_objectSpread({}, prev), {}, {
                    description: {
                      status: 'pending'
                    }
                  });
                });

                /**
                 * TODO: Split out individual API calls to individual calls to avoid the current
                 * request waterfall & use React Query for de-duplication and caching
                 */
                _context.prev = 2;
                _context.next = 5;
                return extractTextFromPdf(fileForAsyncAnalysis);
              case 5:
                text = _context.sent;
                _context.next = 8;
                return api('post', '/api/ai/synopsis', null, {
                  text: text
                });
              case 8:
                _yield$api = _context.sent;
                contentError = _yield$api.error;
                chatGptDescription = _yield$api.content;
                detectedLanguageCode = _yield$api.langCode;
                detectedLocale = getCorrectLanguageCode(detectedLanguageCode);
                setAiSuggestions({
                  locale: detectedLocale ? {
                    status: 'ready',
                    value: detectedLocale
                  } : {
                    status: 'none'
                  },
                  description: {
                    status: contentError ? 'error' : 'ready',
                    value: chatGptDescription
                  }
                });
                setFileForAsyncAnalysis(null);
                isAnalysisInProgressRef.current = false;
                _context.next = 21;
                break;
              case 18:
                _context.prev = 18;
                _context.t0 = _context["catch"](2);
                setAiSuggestions(function (prev) {
                  return _objectSpread(_objectSpread({}, prev), {}, {
                    description: {
                      status: 'error'
                    }
                  });
                });
              case 21:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[2, 18]]);
        }));
        return function extractSummary() {
          return _ref.apply(this, arguments);
        };
      }();
      extractSummary();
    }
  }, [fileForAsyncAnalysis]);
  return {
    aiSuggestions: aiSuggestions,
    analyseFile: setFileForAsyncAnalysis
  };
}